import { API_BASE, getAccessToken } from "@/lib/api/session";
import { getLocale } from "@/i18n";
import { platform } from "@/lib/capacitor";

export type FeedbackSource =
  | "insight"
  | "experiment"
  | "coach"
  | "profile"
  | "nps"
  | "other";

export type SubmitFeedbackInput = {
  source: FeedbackSource;
  sourceId?: string | null;
  rating?: number | null;
  category?: string | null;
  body?: string | null;
};

export async function submitFeedback(
  input: SubmitFeedbackInput
): Promise<{ ok: true; id: string } | { ok: false; message: string }> {
  try {
    const token = await getAccessToken();
    if (!token) {
      return { ok: false, message: "AUTH_REQUIRED" };
    }
    const res = await fetch(`${API_BASE}/api/v1/feedback`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        source: input.source,
        sourceId: input.sourceId ?? null,
        rating: input.rating ?? null,
        category: input.category ?? null,
        body: input.body ?? null,
        locale: getLocale() === "sv" ? "sv-SE" : getLocale(),
        platform,
      }),
    });
    if (!res.ok) {
      const err = (await res.json().catch(() => ({}))) as { error?: string };
      return { ok: false, message: err.error ?? "SAVE_FAILED" };
    }
    const data = (await res.json()) as { id: string };
    return { ok: true, id: data.id };
  } catch {
    return { ok: false, message: "NETWORK" };
  }
}
